/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useMemo,useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { AdjustmentDetailTable } from './tableHead';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getCmsAdjustment, setFinalGroupByQtr } from '../Store/action';
import { quarterComparator } from '../../../../SharedModules/DateUtilities/DateUtilities';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';



const DisplayCmsReport = () => {
  const {
    displayObj: {
      rebateCategoryValue,
      contactsValue: getContactsList,
      rebateProgramName: getRebateProgramName,
      groupOfRebateProgramList: allRebateProgramList,
      rebateGroupCategoryValue: getRebateProgramGroupName,
      startQtr: startQtrValue,
      adjustmentData: getadjustmentData,
      selectedOptionValue: getSelectedOptionData,
    },
  } = useSelector((state) => state?.sharedState?.CmsAdjustReducer);
  const finalGroupByQtr = useSelector(
    (state) => state?.sharedState?.CmsAdjustReducer?.finalGroupByQtr
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [adjustment, setAdjustment] = React.useState();
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [tableCount, setTableCount] = useState(0);

  function convertInput(input) {
    const datePattern = /\d{2}\/\d{2}\/\d{4}/;
    const quarterPattern = /\dQ\d{4}/;

    if (datePattern.test(input)) {
      return convertDateRange(input);
    }
    if (quarterPattern.test(input)) {
      return input;
    }
  }
  // converting mm/dd/yyyy to mQyyyy
  function convertDateRange(dateRange) {
    const dates = dateRange.split(' - ');
    const startDate = new Date(dates[0]);

    const startQuarter = Math.floor(startDate.getMonth() / 3 + 1);
    const startYear = startDate.getFullYear();

    const formattedString = `${startQuarter}Q${startYear}`;

    return formattedString;
  }

  const fromRange = convertInput(startQtrValue);

  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  function getQuarterDates(quarter) {
    const year = parseInt(quarter?.slice(-4));
    const quarterNum = parseInt(quarter?.slice(0, 1));
    let startDate;
    let endDate;

    switch (quarterNum) {
      case 1:
        startDate = new Date(year, 0, 1);
        endDate = new Date(year, 2, 31);
        break;
      case 2:
        startDate = new Date(year, 3, 1);
        endDate = new Date(year, 5, 30);
        break;
      case 3:
        startDate = new Date(year, 6, 1);
        endDate = new Date(year, 8, 30);
        break;
      case 4:
        startDate = new Date(year, 9, 1);
        endDate = new Date(year, 11, 31);
        break;
    }

    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    const startStr = startDate?.toLocaleDateString('en-US', options);
    const endStr = endDate?.toLocaleDateString('en-US', options);

    return { startDate: startStr, endDate: endStr };
  }
  const qtr = getQuarterDates(fromRange);
  const stringParts = getRebateProgramGroupName?.split(' | ');
  const groupCode = stringParts[0]?.trim();

  React.useEffect(() => {
    setAdjustment(getadjustmentData?.cmsreportAdjustmentDetailsVO);
    if (
      getadjustmentData?.cmsreportAdjustmentDetailsVO &&
      finalGroupByQtr.length === 0
    ) {
      const sortedAdjustmentData =
        getadjustmentData?.cmsreportAdjustmentDetailsVO.sort((p1, p2) =>
          quarterComparator(p2.qtr, p1.qtr)
        );
      const qtrs = [
        ...new Set(
          sortedAdjustmentData
            ?.sort((p1, p2) => quarterComparator(p2.qtr, p1.qtr))
            ?.map((o) => o.qtr)
        ),
      ];
      let newArray = [];
      for (let i = 0; i < qtrs.length; i += 1) {
        const currQtr = sortedAdjustmentData
          ?.sort((a, b) => {
            return (
              parseFloat(a.ndc?.toString()?.replace(/\-/g, '')) -
              parseFloat(b.ndc?.toString()?.replace(/\-/g, ''))
            );
          })
          .filter((el) => {
            return el.qtr === qtrs[i];
          });

        newArray = [...newArray, ...currQtr];
        const obj = {
          ndc: `subTotal for ${qtrs[i]}: `,
          adjustmentAmt: sumofQtr(currQtr),
        };
        newArray.push(obj);
      }
      setRowData(newArray);
      // mappedData(sortedAdjustmentData, 0);
    }
  }, [getadjustmentData]);
  // React.useEffect(() => {
  //   if (finalGroupByQtr.length != 0) {
  //     let dataToRemove = finalGroupByQtr;
  //     let removeTotalObj = dataToRemove.filter(function (el) {
  //       return el.ndc.substring(0, 8) != 'subTotal';
  //     });
  //     let sortedAdjustmentData =
  //       getadjustmentData?.cmsreportAdjustmentDetailsVO.sort((p1, p2) =>
  //         p1.qtr > p2.qtr ? 1 : p1.qtr < p2.qtr ? -1 : 0
  //       );
  //     mappedData(sortedAdjustmentData, removeTotalObj.length + 1);
  //   }
  //   if (finalGroupByQtr?.length > 0) {
  //     setTimeout(() => {
  //       setRowData(finalGroupByQtr);
  //     }, 3000);
  //   }
  // }, [finalGroupByQtr]);
  // const mappedData = (data, findIndex) => {
  //   let getduplicateQtr = data[findIndex]?.qtr;
  //   if (getduplicateQtr) {
  //     let newArray = data.filter(function (el) {
  //       return el.qtr === getduplicateQtr;
  //     });
  //     let obj = {
  //       ndc: 'subTotal for ' + newArray[0].qtr + ':',
  //       adjustmentAmt: sumofQtr(newArray),
  //     };
  //     newArray.push(obj);
  //     dispatch(setFinalGroupByQtr(newArray));
  //   }
  // };

  const sumofQtr = (newArray) => {
    const displayedRows = newArray;
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator +
        (object.adjustmentAmt ? parseFloat(object.adjustmentAmt) : null)
      );
    }, 0);
    return data;
  };
  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
        adjustmentAmt: parseFloat(
          item.adjustmentAmt.replace('$', '').replace(/,/g, '')
        ),
      };
    });
    setFilteredRow(updatedRowData);
  };
  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';

  firstInfo = `Adjustments between: ${`${qtr.startDate}-${qtr.endDate}`}`;
  secondInfo = `Period: ${startQtrValue}`;
  thirdInfo = `${
    getSelectedOptionData === 'Single'
      ? `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`
      : rebateCategoryValue
  }`;
  // pinned row
  const [displayedRows, setDisplayedRows] = React.useState(adjustment ?? []);

  const sum = (property) => {
    const displayedRows =
      filteredRows.length > 0 ? filteredRows : adjustment ?? [];
    const mainRows = displayedRows.filter(
      (row) => !(row.ndc && row.ndc.startsWith('subTotal for'))
    );

    if (property === 'checkLogNum') {
      return `${mainRows.length} Checks`;
    }

    const total = mainRows.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : 0)
      );
    }, 0);

    return total ? parseFloat(total).toFixed(2) : '0.00';
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        qtr: 'Total',
        adjustmentAmt: sum('adjustmentAmt'),
        bold: true,
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [adjustment, filteredRows]);
const totalCount = rowData.length;
const subTotalCount = rowData.filter(
  row => typeof row.ndc === "string" && row.ndc.trim().startsWith("subTotal for")
).length;
const finalCount = totalCount - subTotalCount;
  return (
    <div className="tBillPanel custom-check  tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display CMS Report Adjustment Detail"
      />{' '}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="db">
                <div className="row">
                  <div className="col-4">
                    <div className=" frr-other-calc vertical-wrapper">
                      <div className="mui-custom-form row row-wrap input-md ml-2 mr-2">
                        <TextField
                          id="Rebate_Program"
                          label={
                            getSelectedOptionData === 'Single'
                              ? 'Rebate Program'
                              : 'Group'
                          }
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Rebate_Program' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            getSelectedOptionData == 'Single'
                              ? `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`
                              : rebateCategoryValue
                          }
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className=" vertical-wrapper">
                      <div className="mui-custom-form row row-wrap input-md mr-2">
                        <TextField
                          label="Quarter "
                          id="Quarter1"
                          fullWidth
                          placeholder=""
                          inputProps={{ id: 'Quarter1' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={startQtrValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
          <TableGrid
            data-testid="Adjustment-Detail"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            hideTotalCount={true}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={rowData?.map((item) => {
              return {
                ...item,
                adjustmentAmt: item.adjustmentAmt
                  ? `$ ${item.adjustmentAmt?.toFixed(2)}`
                  : '$0.00',
              };
            })}
            onFilterData={onFilterChanged}
            columnDefs={AdjustmentDetailTable}
            exportFile
            noGlobalSort
            animateRows
            isScrollOn
            sideBar={false}
            fileName="CMS Report adjustment Detail Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, secondInfo, thirdInfo }}
          />
           <p className="total-results" tabIndex="0">
              Total Results: <b>{finalCount?.toLocaleString('en-US')}</b>
            </p>
        </div>
      </div>
    </div>
  );
};

export default DisplayCmsReport;
